import styled from '@emotion/styled';
export const Message = styled.div`
  font-size: 18px;
  font-weight: 500;
  justify-content: center;
  text-align: center;
`;
